export const SNACKBAR_WEBSOCKET_RESTORED = "WEBSOCKET_RESTORED";
export const SNACKBAR_VERSION_LOCKED = "VERSION_LOCKED";
export const SNACKBAR_ESTIMATE_ARCHIVED = "ESTIMATE_ARCHIVED";
export const SNACKBAR_ESTIMATE_READONLY = "ESTIMATE_READONLY";

export const JIRA_UPLOAD = {
  SUCCESS: "jira_project_success",
  WARNING: "jira_project_warning",
  ERROR: "jira_project_error",
};